module.exports = __webpack_public_path__ + "static/img/30014 (2).39cd30a.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30014 (2).webp
// module id = xm61
// module chunks = 14